import { Modal, Button } from "react-bootstrap";
import RetreatTeamSection from "./RetreatTeamSection";

function CreateRetreatTeam({
  show,
  allCoupleData,
  priestsList = [],
  rolesDataList,
  roles,
  ediUserIdClicked,
  handleClose,
  getRolesOfRetreats,
  onTeamChange,
  onPeopleRefresh,
  setEditIndex,
  editIndex,
}) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      className="customSubAdminModal"
      backdropClassName="cr-popup-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">Add Retreat Team</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <RetreatTeamSection
          allCoupleData={allCoupleData}
          priestsList={priestsList}
          rolesDataList={rolesDataList}
          roles={roles}
          retreatId={ediUserIdClicked}
          getRolesOfRetreats={getRolesOfRetreats}
          onTeamChange={onTeamChange}
          onPeopleRefresh={onPeopleRefresh}
          setEditIndex={setEditIndex}
          editIndex={editIndex}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} className="cr-popup-close px-4">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateRetreatTeam;
